import { NetworkIdSchema } from "#network/network.js";
import z$1 from "zod";
//#region src/cards/justShippedCard.ts
const JustShippedCardSchema = z$1.object({
	title: z$1.string(),
	description: z$1.string(),
	url: z$1.string().url(),
	ctaLabel: z$1.string().optional(),
	networkId: NetworkIdSchema.optional()
});
//#endregion
export { JustShippedCardSchema };

//# sourceMappingURL=justShippedCard.js.map